import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'

import monofullBrandWhite from 'assets/svgs/monoful-brand-white.svg'
import { ROUTES } from 'config/routes'
import { DELIVERY_WORK_QUERY_KEY, DELIVERY_WORK_ACTION } from 'constants/deliveryWorkQueryParams'

import type { DeliveryReportHeaderProps } from './type'
import styles from './index.module.css'

export const DeliveryReportHeader: React.FC<DeliveryReportHeaderProps> = ({
  title,
  deliveryReportUid,
  onNewDelivery,
}) => {
  const history = useHistory()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev)
  }, [])

  const navigateTo = useCallback(
    (path: string) => {
      setIsMenuOpen(false)
      history.push(path)
    },
    [history]
  )

  const listPath = (status: string) =>
    `${ROUTES.spDeliveryList.replace(':deliveryReportUid', deliveryReportUid)}?status=${status}`

  return (
    <div className={styles.bar}>
      <div className={styles.brand}>
        <img src={monofullBrandWhite} alt="hacobell brand" className={styles.logo} />
        <span className={styles.title}>トラック簿 | {title}</span>
      </div>
      <div className={styles.menuWrapper}>
        <button className={styles.menuButton} onClick={toggleMenu} aria-label="メニューを開く">
          <span className={styles.dots}>•••</span>
        </button>
        {isMenuOpen && (
          <>
            <div className={styles.backdrop} onClick={() => setIsMenuOpen(false)} />
            <div className={styles.menu}>
              <button
                className={`${styles.menuItem} ${styles.menuItemPrimary}`}
                onClick={() => {
                  if (onNewDelivery) {
                    setIsMenuOpen(false)
                    onNewDelivery()
                  } else {
                    navigateTo(
                      `/sp/delivery-report/${deliveryReportUid}?${DELIVERY_WORK_QUERY_KEY}=${DELIVERY_WORK_ACTION.START_SHIPMENT}`
                    )
                  }
                }}
              >
                新規配送開始
              </button>
              <button className={styles.menuItem} onClick={() => navigateTo(listPath('active'))}>
                配送中一覧
              </button>
              <button className={styles.menuItem} onClick={() => navigateTo(listPath('completed'))}>
                配送完了一覧
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
